import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {DndModule} from 'ngx-drag-drop';
import {TranslocoModule} from '@ngneat/transloco';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faAlignLeft} from '@fortawesome/pro-light-svg-icons/faAlignLeft';
import {faAlignCenter} from '@fortawesome/pro-light-svg-icons/faAlignCenter';
import {faAlignRight} from '@fortawesome/pro-light-svg-icons/faAlignRight';
import {faClone} from '@fortawesome/pro-solid-svg-icons/faClone';
import {faTrash} from '@fortawesome/pro-solid-svg-icons/faTrash';
import {faPlusCircle} from '@fortawesome/pro-light-svg-icons/faPlusCircle';
import {faChevronDown} from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import {faPlus, faTable} from '@fortawesome/pro-regular-svg-icons';

import {RichTextModule} from './rich-text/rich-text.module';
import {ImageModule} from './image/image.module';
import {VideoModule} from './video/video.module';
import {SignatureInputModule} from './input/signature-input/signature-input.module';
import {TextInputModule} from './input/text-input/text-input.module';
import {SpacerModule} from './spacer/spacer.module';
import {DividerModule} from './divider/divider.module';
import {RadioInputModule} from './input/radio-input/radio-input.module';
import {ButtonModule} from './button/button.module';
import {CheckboxInputModule} from './input/checkbox-input/checkbox-input.module';
import {BankAccountInputModule} from './input/bank-account-input/bank-account-input.module';
import {DateInputModule} from './input/date-input/date-input.module';
import {FileUploadInputModule} from './input/file-upload-input/file-upload-input.module';
import {AttachmentModule} from './attachment/attachment.module';
import {ScrollingModule} from 'projects/shared/scrolling/scrolling.module';
import {BlockSelectionModule} from '@shared/directives/block-selection/block-selection.module';
import {DraggableModule} from './draggable/draggable.module';
import {BlockComponent} from './block/block.component';
import {PageComponent} from './page/page.component';
import {GroupComponent} from './group/group.component';
import {RowComponent} from './row/row.component';
import {ColumnComponent} from './row/column/column.component';
import {PagePlaceholderComponent} from './page/page-placeholder/page-placeholder.component';
import {BlockOwnerColorizationModule} from '@shared/directives/block-owner-colorization/block-owner-colorization.module';
import {DragHandleModule} from '@shared/controls/drag-handle/drag-handle.module';
import {DropdownModule} from '@paperlessio/sdk/components/dropdown';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {TableModule} from '@blocks/table/table.module';
import {PdfPartComponent} from './pdf-part/pdf-part.component';
import {PdfPartChildComponent} from './pdf-part/pdf-part-child.component';
import {AbsoluteDragModule} from '@shared/absolute-drag/absolute-drag.module';
import {ResizableModule} from '@shared/resizable/resizable.module';
import {DataSetInputComponent} from './input/data-set-input/data-set-input.component';
import {DataSetInputRowComponent} from './input/data-set-input/data-set-input-row/data-set-input-row.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {SubmissionGizmoModule} from '@shared/submission-gizmo/submission-gizmo.module';
import {PageBreakComponent} from '@blocks/page-break/page-break.component';
import {BlockVisibilityDirective} from '@blocks/block/block-visibility.directive';
import {
  DataSetInputRowDeleteButtonComponent
} from '@blocks/input/data-set-input/data-set-input-row-delete-button/data-set-input-row-delete-button.component';
import {RequiredIndicatorComponent} from '@shared/controls/required-indicator/required-indicator.component';
import {IconLibraryService, IconsModule} from '@paperlessio/sdk/icons';
import {HtmlModule} from '@blocks/html/html.module';

@NgModule({
  declarations: [
    BlockComponent,
    GroupComponent,
    PageComponent,
    RowComponent,
    ColumnComponent,
    PagePlaceholderComponent,
    PdfPartComponent,
    PdfPartChildComponent,
    DataSetInputComponent,
    DataSetInputRowComponent
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
    DndModule,
    ScrollingModule,
    RichTextModule,
    ImageModule,
    VideoModule,
    SignatureInputModule,
    TextInputModule,
    SpacerModule,
    DividerModule,
    RadioInputModule,
    ButtonModule,
    CheckboxInputModule,
    BankAccountInputModule,
    DateInputModule,
    FileUploadInputModule,
    AttachmentModule,
    TranslocoModule,
    BlockSelectionModule,
    DraggableModule,
    DragHandleModule,
    DropdownModule,
    ClipboardModule,
    TableModule,
    SubmissionGizmoModule,
    BlockOwnerColorizationModule,
    AbsoluteDragModule,
    IconsModule,
    DragDropModule,
    ResizableModule.forRoot(),
    PageBreakComponent,
    BlockVisibilityDirective,
    DataSetInputRowDeleteButtonComponent,
    RequiredIndicatorComponent,
    HtmlModule
  ],
  exports: [
    BlockComponent,
    GroupComponent,
    PageComponent,
    RowComponent,
    ColumnComponent,
    PagePlaceholderComponent,
    PdfPartComponent,
  ]
})
export class BlocksModule {
  constructor(library: FaIconLibrary, iconLibrary: IconLibraryService) {
    library.addIcons(faAlignLeft, faAlignCenter, faAlignRight, faClone, faTrash, faPlus, faPlusCircle, faChevronDown, faTable);
  }
}
